/* eslint-disable camelcase */
import {
  filters,
  moreFilters,
  sorts,
} from '@/components/search/hooks/useMoreFilters'
import { convertUrlToParamsObject } from './props'
import { midTermFeatures } from '@/components/search/filters/filtersMenu/constants/midTermFeatures'

type ISearchUtils = {
  queryParams: any
  perPage: number
  city?: string | string[]
  province?: string | string[]
  tag?: string | string[]
  ctx?: any
  village?: string | string[]
}

export const makeAPIRequest = ({
  queryParams,
  perPage,
  city,
  province,
  tag,
  ctx,
  village,
}: ISearchUtils) => {
  const moreFiltersList = [...moreFilters, ...midTermFeatures]
  const list = [...filters, ...moreFiltersList.flatMap(item => item.list)]
  const apiParams = {}
  const seoItems: string[] = []
  const seoQueries: string[] = []
  // const specialDiscount =
  //   queryParams?.special_discount || queryParams?.special_discount
  const hasVideo = queryParams?.has_video

  list.forEach((item: any) => {
    const field = queryParams[item.query]
    if (field) {
      // Detect array types data
      if (item.api?.includes('[]')) {
        const APIName = item.api.replace('[', '').replace(']', '')
        if (!apiParams[APIName]?.length) {
          apiParams[APIName] = []
        }
        if (!apiParams[APIName]?.includes(item.aValue)) {
          apiParams[APIName].push(item.aValue ?? field)
        }
      } else {
        apiParams[item.api] = item.aValue ?? field
        if (item.hasOwnProperty('seo')) {
          seoItems.push(item.title)
          seoQueries.push(item.query)
        }
      }
      if (item.hasOwnProperty('seo')) {
        apiParams['meta_tags'] = [
          ...(apiParams['meta_tags'] ?? []),
          item.meta_tags || item.query,
        ]
      }
    }
  })

  if (ctx?.req?.url) {
    if (convertUrlToParamsObject(ctx?.req?.url).parent_id) {
      apiParams['parent_id'] = convertUrlToParamsObject(ctx?.req?.url).parent_id
    }
  }

  if (queryParams?.host_uid) {
    apiParams['host_uid'] = queryParams.host_uid
  }

  if (queryParams?.sortBy) {
    const sort = sorts.find(item => item.qٰValue === +queryParams?.sortBy)
    if (sort) {
      apiParams[sort?.api] = sort.aValue
    }
  }
  apiParams['perpage'] = perPage
  city && (apiParams['city'] = [city])
  province && (apiParams['province'] = [province])
  tag && (apiParams['tag'] = [tag])
  if (village) {
    apiParams['village'] = [village]
  } else if (queryParams?.village) {
    apiParams['village'] = Array.isArray(queryParams.village)
      ? queryParams.village
      : [queryParams.village]
  }
  if (queryParams?.co_ordinates) {
    const co_ordinates = queryParams.co_ordinates.split(',')
    apiParams['co_ordinates[max_latitude]'] = co_ordinates[0]
    apiParams['co_ordinates[max_longitude]'] = co_ordinates[1]
    apiParams['co_ordinates[min_latitude]'] = co_ordinates[2]
    apiParams['co_ordinates[min_longitude]'] = co_ordinates[3]
  }

  // if (specialDiscount) {
  //   if (
  //     queryParams?.special_discount_city ||
  //     queryParams?.special_discount_city
  //   ) {
  //     apiParams['city[]'] =
  //       queryParams?.special_discount_city || queryParams?.special_discount_city
  //   } else if (
  //     queryParams?.special_discount_province ||
  //     queryParams?.special_discount_province
  //   ) {
  //     apiParams['province[]'] =
  //       queryParams?.special_discount_province ||
  //       queryParams?.special_discount_province
  //   }
  //   apiParams['special_discount'] = 1
  // }

  if (queryParams?.place_id) {
    apiParams['place_id'] = queryParams.place_id
  }

  if (
    queryParams?.['user_co_ordinates[longitude]'] &&
    queryParams?.['user_co_ordinates[latitude]']
  ) {
    apiParams['user_co_ordinates[longitude]'] =
      queryParams?.['user_co_ordinates[longitude]']
    apiParams['user_co_ordinates[latitude]'] =
      queryParams?.['user_co_ordinates[latitude]']
  }

  if (hasVideo) {
    apiParams['has_video'] = 1
  }

  if (queryParams?.cancel) {
    apiParams['cancel'] = queryParams?.cancel
  }

  if (queryParams?.cancel_link_type) {
    apiParams['cancel_link_type'] = queryParams.cancel_link_type
  }

  if (queryParams?.hide_test) {
    apiParams['hide_test'] = queryParams.hide_test
  }

  if (queryParams?.from_map_nearby) {
    apiParams['from_map_nearby'] = queryParams.from_map_nearby
  }

  if (queryParams?.mid_term) {
    apiParams['mid_term'] = queryParams.mid_term
    apiParams['meta_tags'] = [...(apiParams['meta_tags'] ?? []), 'mid_term']
  }

  // To invalid search api cache
  if (queryParams?.cache) {
    apiParams['cache'] = queryParams.cache
  }

  return { apiParams, seoItems, seoQueries }
}
